// components/ConfirmationModal.jsx
import React from "react";
import Button from "components/Button";
import ProcessingBar from "utils/Processingbar";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isProcessing,
  paymentMethod,
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleOverlayClick}
    >
      <div className="bg-white dark:bg-drylight rounded-2xl shadow-xl p-6 max-w-md w-full space-y-4 border border-textGray">
        <h3 className="text-xl font-bold text-center text-neutral-800 dark:text-white border-b border-textGray pb-3">
          Confirm
        </h3>

        <p className="text-sm text-center text-neutral-700 dark:text-text">
          {paymentMethod === "online" ? (
            <>
              You are about to place your order and proceed to secure payment
              via Stripe.
            </>
          ) : (
            <>
              You are about to place your order. Payment will be completed at
              the counter.
            </>
          )}
        </p>

        <p className="text-[12px] text-center text-neutral-500 dark:text-textGray italic">
          <span className="text-redlight">(*)</span> Please review all details
          carefully. Once confirmed, this action cannot be undone.
        </p>

        <div className="flex justify-center gap-4 pt-4 border-t border-textGray">
          <Button
            inverse
            onClick={onClose}
            className="px-6 py-2 rounded-full border text-sm"
          >
            Cancel
          </Button>

          <Button
            big
            onClick={onConfirm}
            disabled={isProcessing}
            className="px-6 py-2 bg-redlight text-white rounded-full min-w-[140px]"
          >
            {isProcessing ? (
              <ProcessingBar />
            ) : paymentMethod === "online" ? (
              "Pay with 💳 Stripe"
            ) : (
              "Place Order"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
